// Cursor event for 'pretty mediterranean' to move the background in info boxes
var bgInfoImgBlocks = document.getElementsByClassName('info-with-bg');
if(bgInfoImgBlocks.length > 0){
  window.addEventListener('mousemove', (event)=>{
    let blocks = Array.prototype.slice.call(bgInfoImgBlocks);
    blocks.forEach((block)=>{
      let moveHorizontally = 100 - event.clientX / window.innerWidth * 15;
      let moveVertically = 100 - event.clientY / window.innerHeight * 15;
      block.style.backgroundPosition = `${moveHorizontally}% ${moveVertically}%`;
    });
  })
}
